var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_content"},[_c('div',{staticClass:"page_title m-b-30"},[_c('jobseeker-applied-positions',{attrs:{"type":"fullwidth"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }